export const experienceData = [
    {
        id: 1,
        company: 'Toca-organics',
        jobtitle: 'Systems manager',
        startYear: '2022',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Cctraders',
        jobtitle: 'Web developer',
        startYear: 'Dec 2023',
        endYear: 'March 2024'
    },
    {
        id: 3,
        company: 'Suzaness Career Consultancy',
        jobtitle: 'Project Manager',
        startYear: 'Oct 2024',
        endYear: 'Present'
    },
    {
        id: 4,
        company: 'NEXT GEN TECH',
        jobtitle: 'Founder',
        startYear: 'March 2024',
        endYear: 'Present'
    },
    
]